 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		5: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"default~modules-dashboard-desktop-dashboard-desktop-dashboard-module-ngfactory~modules-dashboard-mob~2bf4abff","1":"default~modules-dashboard-desktop-dashboard-desktop-dashboard-module-ngfactory~modules-dashboard-mob~b2fa74c3","2":"default~modules-planning-wizard-desktop-planning-desktop-planning-module-ngfactory~modules-planning-~334a0f84","3":"default~modules-weight-target-desktop-weight-target-desktop-weight-target-module-ngfactory~modules-w~9a5dc6eb","4":"default~modules-wizard-desktop-wizard-desktop-wizard-module-ngfactory~modules-wizard-mobile-wizard-m~44f1d033","8":"common-libs-bitforce-modules-changelog-bitf-changelog-module-ngfactory","10":"modules-dashboard-desktop-dashboard-desktop-dashboard-module-ngfactory","11":"modules-dashboard-mobile-dashboard-mobile-dashboard-module-ngfactory","12":"modules-favorites-favorites-module-ngfactory","13":"modules-info-info-module-ngfactory","14":"modules-planning-wizard-desktop-planning-desktop-planning-module-ngfactory","15":"modules-planning-wizard-mobile-planning-mobile-planning-module-ngfactory","16":"modules-progress-progress-module-ngfactory","17":"modules-weight-target-desktop-weight-target-desktop-weight-target-module-ngfactory","18":"modules-weight-target-mobile-weight-target-mobile-weight-target-module-ngfactory","19":"modules-wizard-desktop-wizard-desktop-wizard-module-ngfactory","20":"modules-wizard-mobile-wizard-mobile-wizard-module-ngfactory"}[chunkId]||chunkId) + "-es5." + {"0":"ddbb9ef660d0486a823f","1":"e54fc774a723705a1b77","2":"ab3a39010041aadc9ca8","3":"e317820b8620e85b2662","4":"2c15a0bc7cb5e5dddd21","6":"47c5d99f2ef51ca0df98","7":"c9c41562c98427893868","8":"572c7a4d5b6536646e05","10":"7966e01ecdc04cde6a97","11":"9d1c49b85da3b8061f26","12":"abc66f8dc8ff9ad72aeb","13":"66b6f96abeae35f6e4bd","14":"48ff75c45c8a232fbc97","15":"27f4ac011165cc7c2459","16":"06bf5cf2a54f5f1a19f0","17":"eb04b76c9a28f7d36446","18":"ab5064dcd0171bd70f40","19":"edfa979ab02e5bef8265","20":"47cdc1198ba11974ce1a"}[chunkId] + ".js"
 	}
 	var sriHashes = {"0":"*-*-*-CHUNK-SRI-HASH-0-*-*-*","1":"*-*-*-CHUNK-SRI-HASH-1-*-*-*","2":"*-*-*-CHUNK-SRI-HASH-2-*-*-*","3":"*-*-*-CHUNK-SRI-HASH-3-*-*-*","4":"*-*-*-CHUNK-SRI-HASH-4-*-*-*","6":"*-*-*-CHUNK-SRI-HASH-6-*-*-*","7":"*-*-*-CHUNK-SRI-HASH-7-*-*-*","8":"*-*-*-CHUNK-SRI-HASH-8-*-*-*","9":"*-*-*-CHUNK-SRI-HASH-9-*-*-*","10":"*-*-*-CHUNK-SRI-HASH-10-*-*-*","11":"*-*-*-CHUNK-SRI-HASH-11-*-*-*","12":"*-*-*-CHUNK-SRI-HASH-12-*-*-*","13":"*-*-*-CHUNK-SRI-HASH-13-*-*-*","14":"*-*-*-CHUNK-SRI-HASH-14-*-*-*","15":"*-*-*-CHUNK-SRI-HASH-15-*-*-*","16":"*-*-*-CHUNK-SRI-HASH-16-*-*-*","17":"*-*-*-CHUNK-SRI-HASH-17-*-*-*","18":"*-*-*-CHUNK-SRI-HASH-18-*-*-*","19":"*-*-*-CHUNK-SRI-HASH-19-*-*-*","20":"*-*-*-CHUNK-SRI-HASH-20-*-*-*","21":"*-*-*-CHUNK-SRI-HASH-21-*-*-*","22":"*-*-*-CHUNK-SRI-HASH-22-*-*-*"};

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);
 				if (script.src.indexOf(window.location.origin + '/') !== 0) {
 					script.crossOrigin = "anonymous";
 				}
 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				script.integrity = sriHashes[chunkId];
 				script.crossOrigin = "anonymous";
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
